import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import buildRedirectUrl from '../../utils/buildRedirectUrl.js';
import qs from 'qs';
import { v4 } from 'uuid';
import ApiClient from '../../lib/apiV2/index.js';
var _excluded = ["appsignal", "isLocal"],
  _excluded2 = ["id", "authenticity_token", "dialog_line", "dialog_token", "dialog_version", "email", "lead_id_code", "recruiter_id", "phone", "region", "form_of_address", "firstname", "lastname", "stepData"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

// The instance of Formwizard client.
var instance = null;
var FormwizardApi = /*#__PURE__*/function (_ApiClient) {
  /**
   * @param {object} appsignal
   */
  function FormwizardApi(_ref) {
    var _this;
    var appsignal = _ref.appsignal,
      isLocal = _ref.isLocal,
      _config = _objectWithoutProperties(_ref, _excluded);
    _classCallCheck(this, FormwizardApi);
    _this = _callSuper(this, FormwizardApi, [isLocal, _config]);
    /**
     * Gets the dialog data for the specified ID
     *
     * @param id
     */
    _defineProperty(_this, "getDialog", function (_ref2) {
      var id = _ref2.id;
      return _this.request({
        url: 'dialogs/{id}.json',
        method: 'get',
        data: {
          id: id
        }
      });
    });
    /**
     * Creates a lead
     *
     * @param id
     *
     * @param {string} authenticity_token
     * @param {string} dialog_line
     * @param {string} dialog_token
     * @param {string} dialog_version
     * @param {string} lead_id_code
     * @param {string} recruiter_id
     *
     * @param {string} email
     * @param {string} phone
     * @param {string} region
     * @param {string} form_of_address
     * @param {string} firstname
     * @param {string} lastname
     *
     * @param {object} stepData
     */
    _defineProperty(_this, "createLead", function (_ref3) {
      var id = _ref3.id,
        authenticity_token = _ref3.authenticity_token,
        dialog_line = _ref3.dialog_line,
        dialog_token = _ref3.dialog_token,
        dialog_version = _ref3.dialog_version,
        email = _ref3.email,
        lead_id_code = _ref3.lead_id_code,
        recruiter_id = _ref3.recruiter_id,
        phone = _ref3.phone,
        region = _ref3.region,
        form_of_address = _ref3.form_of_address,
        firstname = _ref3.firstname,
        lastname = _ref3.lastname,
        stepData = _ref3.stepData,
        rest = _objectWithoutProperties(_ref3, _excluded2);
      return _this.request({
        url: 'leads/{id}',
        method: 'post',
        data: _objectSpread(_objectSpread({
          id: id,
          authenticity_token: authenticity_token,
          dialog_line: dialog_line,
          dialog_token: dialog_token,
          dialog_version: dialog_version,
          email: email,
          lead_id_code: lead_id_code,
          recruiter_id: recruiter_id,
          phone: phone === null || phone === void 0 ? void 0 : phone.trim(),
          region: region,
          form_of_address: form_of_address,
          firstname: firstname === null || firstname === void 0 ? void 0 : firstname.trim(),
          lastname: lastname === null || lastname === void 0 ? void 0 : lastname.trim()
        }, stepData), rest)
      });
    });
    /**
     * Process the lead data and send a create lead request to the API.
     */
    _defineProperty(_this, "processLead", function (_ref4) {
      var config = _ref4.config,
        currentLine = _ref4.currentLine,
        data = _ref4.data,
        dialogId = _ref4.dialogId,
        leadId = _ref4.leadId,
        recruiterId = _ref4.recruiterId,
        stepData = _ref4.stepData,
        values = _ref4.values,
        getAuthenticityToken = _ref4.getAuthenticityToken,
        getVersion = _ref4.getVersion,
        setIsLoading = _ref4.setIsLoading,
        setUserData = _ref4.setUserData;
      setIsLoading(true);
      setUserData(values);
      return _this.createLead({
        id: dialogId,
        authenticity_token: getAuthenticityToken(data),
        dialog_token: dialogId,
        dialog_line: currentLine,
        dialog_version: getVersion(data),
        lead_id_code: leadId,
        recruiter_id: recruiterId,
        email: values.email,
        phone: values.phone,
        form_of_address: values.gender,
        firstname: values.firstName,
        lastname: values.lastName,
        stepData: stepData,
        metadata: {
          wizard_session_id: _this.metadata.sessionId,
          wizard_variant: _this.metadata.variant,
          wizard_referrer: _this.metadata.referrer
        }
      }).then(function (response) {
        var _response$data = response === null || response === void 0 ? void 0 : response.data,
          leadid = _response$data.leadid,
          type = _response$data.object_data.real_estate_type;
        return {
          createdLeadId: leadid,
          redirectUrl: buildRedirectUrl(_objectSpread(_objectSpread({}, values), {}, {
            line: currentLine,
            leadId: leadid,
            type: type,
            config: config
          })),
          response: response
        };
      })["catch"](function (error) {
        setIsLoading(false);
        if (_this.appsignal) {
          _this.appsignal.send(_this.appsignal.createSpan(function (span) {
            span.setAction('Formwizard submission failed');
            span.setError(error);
            span.setTags({
              dialogId: dialogId
            });
          }));
        }
      });
    });
    _this.appsignal = appsignal;
    return _this;
  }
  _inherits(FormwizardApi, _ApiClient);
  return _createClass(FormwizardApi);
}(ApiClient); // Set the Formwizard client instance.
var setInstance = function setInstance(config, metadata) {
  var appsignal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isLocal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  instance = new FormwizardApi({
    appsignal: appsignal,
    isLocal: isLocal,
    baseUrl: config.api.urls.wizard.http
  });
  instance.metadata = metadata || {};
  instance.metadata.sessionId = v4();
  instance.metadata.referrer = qs.parse(window.location.search.slice(1)).origin || window.location.href;
};

// Expose the Formwizard client.
var formwizardApi = function formwizardApi() {
  return instance;
};
export { formwizardApi as default, setInstance };